import React, { useEffect, useState } from "react";
import client from "../../lib/api";
import { CAT_LABEL } from "../../lib/categories";
import { toast } from "sonner";
import { Check, X } from "lucide-react";

export default function ReviewQueue() {
  const [items, setItems] = useState(null);
  const load = () => client.get("/admin/imported").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const act = async (id, action) => {
    await client.post(`/admin/imported/${id}/${action}`);
    toast.success(action === "approve" ? "Published" : "Rejected");
    load();
  };

  return (
    <div data-testid="review-queue">
      <h1 className="font-head font-bold text-3xl uc mb-1">Review Queue</h1>
      <p className="text-gray-500 mb-6">Imported & sensitive stories awaiting editorial approval before publishing</p>
      {!items ? <p>Loading…</p> : items.length === 0 ? (
        <div className="bg-white border border-gray-200 p-12 text-center text-gray-500" data-testid="review-empty">
          No items in the review queue. Run auto-ingestion from the Feeds page to pull latest stories.
        </div>
      ) : (
        <div className="space-y-4">
          {items.map((a) => (
            <div key={a.id} className="bg-white border border-gray-200 p-4 flex gap-4" data-testid={`review-item-${a.id}`}>
              {a.featured_image && <img src={a.featured_image} alt="" className="w-32 h-24 object-cover shrink-0" />}
              <div className="flex-1 min-w-0">
                <div className="flex gap-2 items-center mb-1">
                  <span className="text-[10px] bg-black text-white uc px-1.5 py-0.5">{CAT_LABEL[a.category]?.name || a.category}</span>
                  <span className="text-[10px] bg-yellow-100 text-yellow-700 uc px-1.5 py-0.5">{a.source_name}</span>
                </div>
                <h3 className={`font-head font-bold text-lg ${a.language === "hi" ? "lang-hi" : ""}`}>{a.title}</h3>
                <p className="text-gray-600 text-sm line-clamp-2 mt-1">{a.excerpt}</p>
                {a.editorial_note && <p className="text-xs text-r24-red mt-1">⚠ {a.editorial_note}</p>}
              </div>
              <div className="flex flex-col gap-2 shrink-0">
                <button onClick={() => act(a.id, "approve")} data-testid={`approve-${a.id}`} className="bg-green-600 text-white px-4 py-2 font-bold uc text-xs flex items-center gap-1"><Check size={14} /> Approve</button>
                <button onClick={() => act(a.id, "reject")} data-testid={`reject-${a.id}`} className="bg-gray-200 text-gray-700 px-4 py-2 font-bold uc text-xs flex items-center gap-1"><X size={14} /> Reject</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
